module.exports = __webpack_public_path__ + "img/join-en.1925a242.png";